export default class InquiryFields {

  static readonly call = "inquiries.voice"
  static readonly email = "inquiries.email"
  static readonly first_name = "inquiries.firstName"
  static readonly how_did_you_hear_about_us = "inquiries.how"
  static readonly how_did_you_hear_about_us_other = "inquiries.howOther"
  static readonly last_name = "inquiries.lastName"
  static readonly phone = "inquiries.phone"
  static readonly program = "inquiries.programId"
  static readonly programFilter = "programFilter"
  static readonly role = "inquiries.role"
  // static readonly search = "field_search"
  static readonly sms = "inquiries.sms"
  static readonly status = "inquiries.status"
  // static readonly filter = "field_filter"

}

